var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWebappBlueViews = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 13,
  height: 13,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#webapp_blue_views_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.419 3.814C3.43 2.869 4.869 2 6.499 2c1.631 0 3.07.87 4.081 1.814.51.475.925.984 1.217 1.44.145.227.264.447.347.65.08.193.141.402.141.596 0 .194-.06.403-.141.597a4.23 4.23 0 0 1-.347.65 7.709 7.709 0 0 1-1.217 1.44C9.57 10.13 8.13 11 6.5 11s-3.07-.87-4.081-1.814a7.71 7.71 0 0 1-1.217-1.44 4.229 4.229 0 0 1-.347-.65A1.622 1.622 0 0 1 .714 6.5c0-.194.061-.403.141-.597.083-.202.202-.422.347-.65a7.71 7.71 0 0 1 1.217-1.44ZM8.214 6.5a1.714 1.714 0 1 1-3.429 0 1.714 1.714 0 0 1 3.429 0Z",
  fill: "#2563EB"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "webapp_blue_views_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(.5 .5)",
  d: "M0 0h12v12H0z"
})))));
export default SvgWebappBlueViews;